import type { SharedUsersInDocument } from 'pages/Analysis/types';
import type {
  BasicSuccessResponse,
  DocUserPermissionsResponse,
  DocUserPermissionsRequest,
  HTTPFunctions
} from '../types';

const share = ({ get, post }: HTTPFunctions) => ({
  getUsersShared: (documentId: string) => get<SharedUsersInDocument>(`share/users/shared/${documentId}`),
  getUsersToShare: (documentId: string) => get<DocUserPermissionsResponse>(`share/users/permissions/${documentId}`),
  setUsersToShare: (documentId: string, data: DocUserPermissionsRequest) => post<BasicSuccessResponse>('share/users/permissions', {...data, document_id: documentId})
});

export default share;
